import * as types from '../constants/actionTypes';

export function createNotification({notification, status, data} = {}) {
    return {
        type: types.CREATE_NOTIFICATION
        , notification
        , status
        , data
    };
}
export function deleteNotification({notificationID, status, data} = {}) {
    return {
        type: types.DELETE_NOTIFICATION
        , notificationID
        , status
        , data
    };
}
export function deleteAllNotifications({status, data} = {}) {
    return {
        type: types.DELETE_ALL_NOTIFICATIONS
        , status
        , data
    };
}
export function loadPageNotification({pageSize, status, data} = {}) {
    return {
        type: types.LOAD_NOTIFICATIONS_PAGE
        , pageSize
        , status
        , data
    };
}
export function loadUnreadPageCountNotification({status, data} = {}) {
    return {
        type: types.LOAD_UNREAD_NOTIFICATIONS_PAGE_COUNT
        , status
        , data
    };
}
export function markAllNotificationsAsRead({status, data} = {}) {
    return {
        type: types.MARK_ALL_NOTIFICATIONS_AS_READ
        , status
        , data
    };
}
export function markAsReadNotification({notificationID, status, data} = {}) {
    return {
        type: types.MARK_NOTIFICATION_AS_READ
        , notificationID
        , status
        , data
    };
}
export function markAsUnreadNotification({notificationID, status, data} = {}) {
    return {
        type: types.MARK_NOTIFICATION_AS_UNREAD
        , notificationID
        , status
        , data
    };
}
export function setLoadingFlagForNotificationState() {
    return { type: types.SET_LOADING_FLAG_FOR_NOTIFICATION_STATE };
}
export function undeleteNotification({notificationID, status, data} = {}) {
    return {
        type: types.UNDELETE_NOTIFICATION
        , notificationID
        , status
        , data
    };
}


/** WEBPACK FOOTER **
 ** ./src/app/constants/notificationActions.js
 **/